import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"
import _imports_0 from './assets/logo.png'


const _hoisted_1 = { id: "app" }
const _hoisted_2 = { class: "header-info" }
const _hoisted_3 = { class: "packages-info" }
const _hoisted_4 = ["href"]
const _hoisted_5 = {
  href: "https://github.com/ota-meshi/eslint-plugin-vue-demo",
  target: "_blank"
}
const _hoisted_6 = {
  style: {"transform":"scale(0.8)"},
  version: "1.1",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  class: "octicon octicon-mark-github",
  "aria-hidden": "true"
}
const _hoisted_7 = { class: "main" }
const _hoisted_8 = { class: "footer-info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ESLintPlayground = _resolveComponent("ESLintPlayground")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("img", {
        class: "logo",
        alt: "Vue logo",
        src: _imports_0
      }, null, -1)),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "site-name" }, "eslint-plugin-vue Online Playground", -1)),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.packages, (pkg) => {
          return (_openBlock(), _createElementBlock("a", {
            key: pkg.name,
            href: pkg.homepage,
            target: "_blank"
          }, _toDisplayString(pkg.name) + "@" + _toDisplayString(pkg.version), 9, _hoisted_4))
        }), 128)),
        _createElementVNode("a", _hoisted_5, [
          (_openBlock(), _createElementBlock("svg", _hoisted_6, _cache[0] || (_cache[0] = [
            _createElementVNode("path", {
              "fill-rule": "evenodd",
              d: "M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0 0 16 8c0-4.42-3.58-8-8-8z"
            }, null, -1)
          ])))
        ])
      ])
    ]),
    _createElementVNode("main", _hoisted_7, [
      _createVNode(_component_ESLintPlayground)
    ]),
    _createElementVNode("footer", _hoisted_8, "This site was build at :" + _toDisplayString(_ctx.buildAt), 1)
  ]))
}